<template>
  <div class="container text-center mt-5">
    <p>Connecting your Stripe account...</p>
  </div>
</template>

<script>

import paymentService from '../../api/payments.js'
import swal from 'sweetalert';


export default {
  async mounted() {
    const code = this.$route.query.code;
    const state = sessionStorage.getItem('user');

    if (!code || !state) {
      console.error("Missing Stripe OAuth params");
      swal("Warning", "Missing Stripe connection details. Please try again or contact support.", "warning")
        .then(() => {
          this.$router.push("/Accounts");
        });
      return;
    }

    try {

        await paymentService.handleStripeCallback(code, state);

      // Redirect to regular accounts screen
      swal("Success", "Stripe Account should be connected, please refresh the screen.", "success")
        .then(() => {
            this.$router.push("/Accounts");
        });
    } catch (error) {
      console.error("Stripe connect failed", error.response?.data || error);
      this.$router.push("/Accounts");
    }
  }
};
</script>
